<template>
  <div
    :id="tabDirection=='1'? 'bottom-container' :'top-container'"
    :class="{ 'show-list': isShowList, 'heid-list': !isShowList }"
    style="font-size: 13px"
  >
    <div class="bottom-tab">
      <div class="home">
        <div class="tab_home" @click="addClass(0,'景点')" :id="'id'+0">
          
          <div :style="{ color: activeIndex === 0 ? 'rgb(255,170,1)' : '#8a8a8a' }">{{isEnglish ? tarMap[0].english: tarMap[0].chinese}}</div>
        </div>
       
       
        <div class="tab_home"  v-show="second_service_category.length>0"
            v-for="(v,i) in second_service_category" :key="v.id"
            @click="addClass(i+100,second_service_category[0])"
            :id="'id'+(i+100)"
          >
          
               <div :style="{ color: activeIndex === i+100 ? 'rgb(255,170,1)' : '#8a8a8a' }">{{isEnglish ? v.name_eng:v.name}}</div>

          
        </div>
       
      
        
        <div class="tab_home" @click="addClass(2)" v-show="serviceCenter" :id="'id'+2">
         
          <div :style="{ color: activeIndex === 2 ? 'rgb(255,170,1)' : '#8a8a8a' }">{{ isEnglish ? tarMap[2].english : tarMap[2].chinese }}</div>
        </div>

        <div class="tab_home" v-for="(item,index)  in serviceList" :key="item.id" @click="addClass(index+3,item)" :id="'id'+(index+3)"  v-show="!serviceCenter">
         
                   <div :style="{ color: activeIndex === index+3 ? 'rgb(255,170,1)' : '#8a8a8a' }">{{ isEnglish? item.name_eng:item.name }}</div>

        </div>

         <!-- <div class="tab_home" @click="addClass(1,'路线')" :id="'id'+1">
          <iconx type='ziyuan' color='#8a8a8a' size='18'  :style="{ color: activeIndex === 1 ? 'rgb(255,170,1)' : '#8a8a8a' }"/>
          <div style="color: #707070">{{isEnglish ? tarMap[1].english: tarMap[1].chinese}}</div>
        </div> -->

        

      </div>
      <div class="aslide" @click="showInfo" v-if="tabDirection=='1'">
        <iconx type='up' color='#8a8a8a' v-show="!isShowList"/>
        <iconx type='up2' color='#8a8a8a' v-if="isShowList"/>
      </div>

      <div class="aslide" @click="showInfo" v-if="tabDirection=='2'">
        <iconx type='up' color='#8a8a8a' v-show="isShowList"/>
        <iconx type='up2' color='#8a8a8a' v-show="!isShowList"/>
      </div>

    </div>
    <div class="tab-list"  :id="tabDirection==2 &&isShowList? 'top-tab-list-show':'top-tab-list-hide' ">
        
             <span @click="addClass(0,null,'type')" :class="activeIndex==0? 'on':''">{{isEnglish ? tarMap[0].english: tarMap[0].chinese}}</span>
         
          <span   v-show="second_service_category.length>0"
            v-for="(v,i) in second_service_category" :key="v.id"
            @click="addClass(i+100,second_service_category[0],'type')"
            :class="activeIndex==i+100? 'on':''"
          >
         
               {{ isEnglish ? v.name_eng:v.name}}
          
        </span>
       
          
          <span   @click="addClass(2,null,'type')"  :class="activeIndex==2? 'on':''"  v-show="serviceCenter">{{ isEnglish ? tarMap[2].english : tarMap[2].chinese }}</span>
        
        <span v-for="(item,index)  in serviceList" :key="item.id" @click="addClass(index+3,item,'type')" :class="activeIndex==index+3? 'on':''"   v-show="!serviceCenter">
         
          {{ isEnglish ? item.name_eng:item.name}}
        </span>

         
          
          <!-- <span  @click="addClass(1,'路线','type')" :class="activeIndex==1? 'on':''">{{isEnglish ? tarMap[1].english: tarMap[1].chinese}}</span> -->
        
      <!-- 景点 -->
      <!-- <div v-if="activeIndex === 0">
        <div class="search">
          <div>
            <input type="text" :placeholder=" isEnglish? botMap[1].english : botMap[1].chinese"
              @input="searchAudio(searchText)"
              v-model="searchText"
            />
            <iconx type='sousuo1' color='rgb(255, 170, 1)'/>
          </div>
        </div>
        <ul class="search-list">
          <li
            class="search-item"
            v-for="(item, index) in searchList"
            :key="item.id"
            @click="setCenter(item, index)"
          >
            <div class="flex-left">
              <span class="icon-first">
                <img
                  src="@/static/imgs/laba.png"
                  alt
                />
              </span>
              <span :class="{ 'set-font': isEnglish }" class="name-cont">{{ isEnglish ? item.name_eng : item.name }}</span>
              <span class="play-icon">
                <i
                  class="wack wack-bofang"
                  style="color: rgb(255, 140, 50); font-size: 24px !important"
                  @click.stop="playItem(item, index)"
                  v-if="!item.isPlay"
                >
                </i>
                <i
                  class="wack-bofangzhong1 wack"
                  style="color: rgb(255, 140, 50); font-size: 18px !important"
                  @click.stop="stopItem(item)"
                  v-if="item.isPlay"
                >
                </i>
              </span>
              <span style="vertical-align: bottom">
                <a class="flex-right">
                  <iconx color='#fff' type='daohang1' style="display: inline-block"/>
                  {{isEnglish ? botMap[0].english : botMap[0].chinese}}
                </a>
              </span>
            </div>
          </li>
        </ul>
        <p v-if="!searchList.length" class="search-title">
          {{isEnglish ? botMap[2].english: botMap[2].chinese}}'{{ searchTitle }}'{{ isEnglish? botMap[3].english : botMap[3].chinese}}
        </p>
      </div> -->
      <!-- 路线规划 -->
      <!-- <div v-if="activeIndex === 1">
        <ul class="server-list">
          <li
            class="server-item"
            v-for="(item, index) in lineAddressList"
            :key="index"
            @click="setLineVis(item, index)"
          >
            <div class="flex-left">
               <iconx color='rgb(255, 170, 3)' type='luxian' size='18'/>
              <span class="name-cont">
                {{ isEnglish ? item.name_eng : item.name }}
              </span>
              <iconx color='rgb(255, 170, 3)' type='duigou' size='18'  v-show="lineActiveIndex === index"/>
            </div>
          </li>
        </ul>
      </div> -->
      <!--服务中心-->
      <!-- <div v-if="activeIndex === 2">
        <ul class="server-list" v-if="serverClassList.length === 1">
          <li
            class="server-item"
            v-for="(item, index) in serverAddressList"
            :key="item.id"
            @click="setServerCenter(item, index)"
          >
            <div class="flex-left">
               <span class="icon-first">
              <img :src="item.icon" alt style="width: 30px; height: 30px" class="icon-first"/>
              </span>
              <span :class="{ 'set-font': isEnglish }" class="name-cont">
                {{ isEnglish ? item.name_eng : item.name }}
              </span>
              <span>
                <a class="flex-right">
                  <iconx color='#fff' type='daohang1' style="display: inline-block"/>
                  {{isEnglish? botMap[0].english: botMap[0].chinese}}
                </a>
              </span>
            </div>
          </li>
        </ul>
        <ul v-else class="server-class-list">
          <li v-for="(item, index) in serverClassList"  :key="index"  @click="changeServerClass(item, index)" >
            <span :style="{backgroundColor: classIndex === index ? 'rgb(255, 212, 92)' : '#eee'}">
              {{ isEnglish? item.name_eng : item.name }}
            </span>
          </li>
        </ul>
      </div> -->
      <!-- 二级导览 -->
      <!-- <div v-for="(v,i) in second_service_category" :key="i" v-show="activeIndex === i+100" >
        <ul class="search-list" :style="tabDirection==1?  'top:60px' :'top:0px'">
          <li
            class="search-item"
            v-for="(item, index) in second_service"
            :key="item.id"
            @click="setServerCenter(item, index)"
           v-show="item.className==v.name"
          >
            <div class="flex-left">
              
              <span :class="{ 'set-font': isEnglish }" class="name-cont" style="left:10px">{{  item.name }}</span>
              
              <span style="vertical-align: bottom">
                <a class="flex-right">
                  <iconx color='#fff' type='daohang1' style="display: inline-block"/>
                  {{isEnglish ? botMap[0].english : botMap[0].chinese}}
                </a>
              </span>
            </div>
          </li>
        </ul>
         <p v-if="!searchList.length" class="search-title">
          {{isEnglish ? botMap[2].english: botMap[2].chinese}}'{{ searchTitle }}'{{ isEnglish? botMap[3].english : botMap[3].chinese}}
        </p> 
      </div> -->
      
      <!-- <div v-for="(v,index)  in serviceList" :key="index" v-show="activeIndex===index+3">
       
        <ul class="search-list" :style="tabDirection==1?  'top:60px' :'top:0px'">
          <li
            class="search-item"
            v-for="(item, index) in serverAddressList"
            :key="item.id"
            @click="setServerCenter(item, index)"
            v-show="item.className==v.name"
          >
            <div class="flex-left">
              
              <span :class="{ 'set-font': isEnglish }" class="name-cont" style="left:10px">{{ isEnglish ? item.name_eng : item.name }}</span>
              
              <span style="vertical-align: bottom">
                <a class="flex-right">
                  <iconx color='#fff' type='daohang1' style="display: inline-block"/>
                  {{isEnglish ? botMap[0].english : botMap[0].chinese}}
                </a>
              </span>
            </div>
          </li>
        </ul>
        <p v-if="!searchList.length" class="search-title">
          {{isEnglish ? botMap[2].english: botMap[2].chinese}}'{{ searchTitle }}'{{ isEnglish? botMap[3].english : botMap[3].chinese}}
        </p>
      </div> -->
    </div>

     
  </div>
</template>
<script>
import * as constMap from '@/static/const.js'
import iconx from './iconx'
import eventBus from "@/utils/eventBus.js";
import * as config from "../api/api.js"
import Audio from "@/components/audio";
export default {
  props: {
    NowChose: {
      type: null,
    },
    info: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
    spointx: {
      type: Number,
      default: null,
    },
    spointy: {
      type: Number,
      default: null,
    },
    isEnglish: {
      type: Boolean,
      default: false,
    },
    choseTour:{
      type:Function,
      
    },
    lineUpdate:{
      type:Function
    }
  },
  components:{
    Audio
  },

  data() {
    return {
      activeIndex: 0,
      count: 0,
      searchList: [],
      // bottom: '-190px',
      isShowList: false,
      checkIndex: null,
      searchText: "",
      searchTitle: "",
      serverAddressList: [], // 服务中心列表
      lineAddressList: [], // 路线列表
      isUpdateType: "", // 后台上传还是用户上传
      myselfId: "", // 自己参加过的ID
      checkServerIndex: null,
      isCheckedId: null,
      lastPlayItem: {},
      tarMap: constMap.tarberEnglishMap,
      botMap: constMap.bottomListEnglishMap,
      lineActiveIndex: 0,
      classIndex: 0,
      serviceCenter:false,
      serverClassList: [],
      serviceList:[],
      second_service:[],//二级导览列表
      second_service_category:[],//二级导览导航
      tabDirection:'1',//导航栏放下 1为下  2为上
      className:"景点",
      navgatorIndex: 0,
    };
  },
  watch: {
    info: {
      handler(val) {
        this.tabDirection=val.direction
        this.serverClassList = [...val.serverClassList] || [];
        this.serviceList=[...val.serverClassList] || [];
        this.second_service=[...val.second_service] || []
        this.second_service_category=[...val.second_service_category] || []
        // console.log(123456,val.serverClassList)
        if(config.client==="h5" ){
          this.serviceCenter=false
            if(val.serverClassList.length==0){
              this.serviceCenter=true

            }else{
              this.serviceCenter=false
            }
        }else{
          this.serviceCenter=true
        }
        console.log( this.serviceCenter)

        this.serverClassList.unshift({
          name: '全部',
          name_eng: 'All'
        })
        this.serverAddressList = val.inlet_and_outlet;
        this.lineAddressList = val.path_planning;
        this.serverAddressList.forEach((item) => {
          this.$set(item, "isChecked", false);
        });
      },
    },
    list: {
      handler(val) {
        this.list.forEach((item) => {
          this.$set(item, "isChecked", false);
          this.$set(item, "isPlay", false);
        });
        this.searchList = this.list;
      },
    },
    isShowList: {
      handler(val) {
        eventBus.emit("showTab", val);
      },
    },
  },
  created() {
    // console.log(config)
    


    eventBus.on("closeTab", () => {
      if (this.isShowList === true) {
        this.isShowList = false;
        //  this.bottom = '-190px'
      }
    });
    eventBus.on("closeIcon", (type) => {
      this.searchList.forEach((item) => {
        item.isPlay = false;
      });
    });
    eventBus.on("playIcon", () => {
      this.searchList.forEach((item) => {
        item.isPlay = false;
      });
      let index = this.$parent.$refs.mapAddress.removeIndex;
      this.searchList[index].isPlay = true;
    });
  },
  components: {
    iconx
  },
  mounted() {},
  methods: {
    addClass(index,item,type) {
      console.log(item)
      this.$emit("lineUpdate",false)
     this.isShowList = false;
      if(index>2 || index<0){
         eventBus.emit("remove", index);
        this.changeServerClass(item,index,true)
      }
      if(index==0){
         eventBus.emit("remove", index);
        this.$emit("choseTour",{tourInfo:item,isShow:true})

      }
      this.activeIndex = index;
     

      // if(index==1){
      
      //    eventBus.emit("setLineVis", 0);
      //    eventBus.emit("lineTour",this.lineAddressList[0].bitchIds)
      // }else{
      //    eventBus.emit("setLineVis", -1);

      // }

       this.navgatorIndex = index;

      this.$el.querySelector(`#id${index}`).scrollIntoView({ 
        behavior:"smooth", 
        block: "center", 
        inline: "center"
      });

      // this.$el.querySelector(`#id${index}`).SmallScroll({
      //   ToLeft:"10" // 上边框与视窗顶部平齐。默认值
      // });
      // this.listBoxState=false;

      let timeId;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        // this.listBoxState=true;
      },200);

      // if(index==0 || index==1 ){
       
      //展开的点击后收起列表

      
      // }
    },
    showInfo() {
      this.isShowList = !this.isShowList;
    },
    goHere(name, longitude) {
      let eword = name;
      let epointx = longitude.split(",")[1];
      let epointy = longitude.split(",")[0];
      return `https://apis.map.qq.com/tools/routeplan/spointx=${this.spointx}&spointy=${this.spointy}&epointx=${epointx}&epointy=${epointy}&eword=${this.eword}?referer=myapp&key=${localStorage.getItem("tx_map_key")?localStorage.getItem("tx_map_key"):"BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM"}`;
    },
    setLineVis(data, index) {
      
      this.lineActiveIndex = index;
      this.isShowList=false
      eventBus.emit("setLineVis", index);
    },
    setCenter(data, index) {
      console.log(data)
      if (this.isCheckedId) {
        let item = this.list.find((item) => {
          return this.isCheckedId === item.id;
        });
        if (item) {
          item.isChecked = false;
        }
      }
      // this.searchList[this.checkIndex || 0].isChecked = false
      this.isCheckedId = data.id;
      data.isChecked = true;
      // this.checkIndex = index
      this.isShowList = false;
      // this.bottom = '-190px'
      eventBus.emit("showInfoWindow", data);
    },
    changeIcon() {
      this.searchList.forEach((item) => {
        item.isPlay = false;
      });
    },

    playItem(data, index) {
      // 开启自动播放, 禁止用户自己切换讲解
      if (this.$parent.isOpenAudio) {
        eventBus.emit("showMessage","如需播放该音频,请先关闭右上角自动播放按钮");
        return;
      }
      let mapAddress = this.$parent.$refs.mapAddress;
      // 未支付禁止用户收听该讲解
      if (!mapAddress.isBuy && Number(data.type) === 1) {
        mapAddress.showPrizeDialog();
        return;
      }
      if (JSON.stringify(this.lastPlayItem) !== "{}") {
        eventBus.emit("stopItem", this.lastPlayItem);
      }

      this.searchList.forEach((item) => {
        item.isPlay = false;
      });
      this.searchList[index].isPlay = true;
      data.isPlay = true;
      eventBus.emit("playItem", data);
      this.lastPlayItem = data;
    },
    stopItem(data) {
      data.isPlay = false;
      eventBus.emit("stopItem", data);
    },
    changeServerClass(data, index,isShow) {
      // console.log(data,789789789)
      if(isShow){
      // this.isShowList = true

      }else{
      this.isShowList = false

      }
      console.log(data)
      this.classIndex = index
      eventBus.emit('changeSeverMaker', data)
    },
    searchAudio(val) {
      this.searchList = this.list.filter((item) => {
        return this.isEnglish
          ? item.name_eng.indexOf(val) !== -1
          : item.name.indexOf(val) !== -1;
      });
      if (!this.searchList.length) {
        this.searchTitle = val;
      }
    },
    setServerCenter(data, index) {
      if (this.checkServerIndex || this.checkServerIndex === 0) {
        this.serverAddressList[this.checkServerIndex].isChecked = false;
      }
      eventBus.emit("showServerMap", data);
      data.isChecked = true;
      this.checkServerIndex = index;
      this.isShowList = false;
      // this.bottom = '-190px'
    },
  },
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "wack";
  src:  url('//at.alicdn.com/t/font_992732_u4gt0pfn0k.ttf?t=1603462775159') format('truetype'),
}
.wack-kaiqi3:before {
  content: "\e6a4";
}
i {
  font-size: 17px;
}
.wack {
  display: block;
  font-family: "wack" !important;
  font-size: 17px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.wack-bofangzhong1:before {
  content: "\e692";
}

.wack-bofang:before {
  content: "\e691";
}



#bottom-container {
  position: fixed;
  bottom: -190px;
  z-index: 1000;
  width: 100%;
  height: 242px;
}
#top-container{
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 242px;
}
#top-container.heid-list{
  height: 0;
}
#bottom-container.show-list {
  bottom: 0px;
  transition: bottom 0.35s ease-in-out;
}
#bottom-container.heid-list {
  bottom: -190px;
  transition: bottom 0.2s ease-in-out;
}

#top-container #top-tab-list-show {
  top: 53px;
  transition: top 0.35s ease-in-out;
}
#top-container #top-tab-list-hide {
  
  top: -195px;
  transition: top 0.2s ease-in-out;
}
.bottom-tab {
  width: 100%;
  height: auto;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.07);
  // position: fixed;
  // bottom: 0;
  z-index: 99;
  top: 0;
  display: flex;
  justify-content: space-between;
    // overflow-x: auto;

  .home {
    width: 87%;
    height: 100%;
    display: flex;
    // justify-content: space-around;
    overflow-x: auto;
justify-content: space-between;

    .tab_home {
      width: auto;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      margin-top: 6px;
      flex-basis: 172rpx;
      flex-shrink: 0;
      div {
        font-size: 16px;
      }
    }
    .active {
      color: red !important;
    }
  }
  ::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
  .aslide {
    width: 13%;
    height: 100%;
    position: relative;
    i {
      width: 100%;
      height: 100%;
      display: block;
      text-align: center;
      line-height: 52px;
    }
  }
}
#top-container .bottom-tab {
  width: 100%;
  height: 53px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.07);
  position: fixed;
  // bottom: 0;
  z-index: 999;
  top: 0;
  display: flex;
  justify-content: space-between;
    // overflow-x: auto;

  .home {
    width: 87%;
    height: 100%;
    display: flex;
    // justify-content: space-around;
    overflow-x: auto;
justify-content: space-between;

    .tab_home {
      width: auto;
      font-size: 16px;
      min-width: 33%;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      margin-top: 6px;
      flex-basis: 172rpx;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      box-sizing: border-box;
      div {
        font-size: 16px;
      }
    }
    .active {
      color: red !important;
    }
  }
  ::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
  .aslide {
    width: 13%;
    height: 100%;
    position: relative;
    i {
      width: 100%;
      height: 100%;
      display: block;
      text-align: center;
      line-height: 52px;
    }
  }
}

.tab-list {
 
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  // background-color: rgba(250, 252, 246, 0.9);
  z-index: 99 !important;
  span{
    flex: none;
    display: flex;
    align-items: center;
    background: #eee;
    padding: 5px 15px;
    box-sizing: border-box;
    margin: 8px;
    border-radius: 50px;
    color: #000;
    height: 31.5px;

  }
  .on{
    color: rgb(255,170,1);
  }
}
#top-container .tab-list {
  position: fixed;
  top: 53px;
  width: 100%;
  // height: 190px;
  background-color: rgba(250, 252, 246, 0.9);
}

#bottom-container .search {
  width: 100%;
  height: 35px;
  position: absolute;
  top: 65px;
  div {
    width: 96%;
    height: 28px;
    margin-left: 2%;
    position: relative;
    input {
      width: 100%;
      height: 36px;
      border-radius: 20px;
      border: 1px solid #f4f4f4;
      padding-left: 27px;
      display: block;
      margin: 0 auto;
      box-sizing: border-box;
    }
    input:focus {
      border: 1px solid #f4f4f4;
      outline: none;
    }
    i {
      position: absolute;
      left: 9px;
      top: 5.8px;
    }
  }
}
.search {
  width: 100%;
  height: 35px;
  position: absolute;
  top: 5px;
  div {
    width: 96%;
    height: 28px;
    margin-left: 2%;
    position: relative;
    input {
      width: 100%;
      height: 36px;
      border-radius: 20px;
      border: 1px solid #f4f4f4;
      padding-left: 27px;
      display: block;
      margin: 0 auto;
      box-sizing: border-box;
    }
    input:focus {
      border: 1px solid #f4f4f4;
      outline: none;
    }
    i {
      position: absolute;
      left: 9px;
      top: 5.8px;
    }
  }
}
.search-list,
.server-list {
  position: absolute;
  width: 100%;
  height: 140px;
  overflow: auto;
  .search-item,
  .server-item {
    width: 100%;
    height: 50px;
    line-height: 50px;
    // position: relative;
    display: flex;
    justify-content: space-between;
    width: 96%;
    margin-left: 2%;
    .flex-left {
      // width: calc(100% - 80px);
      flex: 1;
      display: flex;
      position: relative;
      justify-content: space-between;
      img {
        width: 24px;
        height: auto;
        vertical-align: middle;
      }
      span {
        // height: 100%;
        // line-height: 50px;
        display: inline-block;
        font-size: 13px;
        letter-spacing: 1px;
        font-weight: 560;
      }
      .icon-first {
        position: relative;
        img {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .name-cont {
        text-align: left;
        flex: 1;
        // max-width: calc(100% - 80px - 85px);
        overflow: hidden;
        width: auto;
        line-height: 50px;
        height: 50px;
        text-align: justify;
        text-justify: newspaper;
        word-break: break-all;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 30px;
        display: inline-block;
        // width: calc(100% - 80px - 80px);
      }
      .play-icon {
        position: absolute;
        right: 110px;
        top: 50%;
        transform: translateY(-50%);
      }
      .set-font {
        // font-size: 13px;
      }

      i {
        // margin-left: 10px;
        font-size: 13px !important;
      }
    }
    .flex-right {
      width: 100px;
      height: 29px;
      // margin-top: 10.5px;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      background: linear-gradient(left, rgb(254, 184, 7), rgb(255, 140, 50));
      border-radius: 15px;
      line-height: 29px;
      text-align: center;
      color: #fff;
      font-size: 13px;
      display: inline-block;
    }
  }
}
#top-container .search-list{
  top: 40px;
}
.search-list {
  top: 100px;
}
.server-list {
  top: 70px;
}
.search-title {
  text-align: center;
  position: absolute;
  top: 103px;
  width: 100%;
  font-size: 14px;
  letter-spacing: 1px;
}
.server-list {
}
.server-class-list {
  li {
    height: 55px;
    width: 25%;
    float: left;
    padding: 0 10px;
    box-sizing: border-box;
    list-style: none;
    span {
      background-color:#eee;
      border-radius: 20px;
      text-align: center;
      font-size: 13px;
      height: 26px;
      line-height: 26px;
      display: block;
      margin-top: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      box-shadow: 0px 0px 2px 	#DCDCDC
    }

  }
  .checked-server {
     div {
       background-color: rgb(255, 212, 92);
     }
   }
}
</style>



// WEBPACK FOOTER //
// src/components/bottomTab.vue